/**
 * Evaluates a required_if expression based on form values
 * @param expression - Expression string like "nama == 'purwa'"
 * @param formValues - Object containing form values from form.watch()
 * @returns Boolean indicating if the condition is met
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const evaluateExpression = (expression: string, formValues: Record<string, any>): boolean => {
  try {
    if (!expression || expression.trim() === '') {
      return false;
    }

    // Create a safe evaluation context with form values
    // Replace field names with their actual values
    let safeExpression = expression;
    
    // Find all field references in the expression
    // Updated pattern to handle field names with hyphens, underscores, and alphanumeric characters
    const fieldMatches = expression.match(/[a-zA-Z_][a-zA-Z0-9_-]*/g);
    
    if (fieldMatches) {
      // Replace each field name with its value
      fieldMatches.forEach(fieldName => {
        const fieldValue = formValues[fieldName];
        
        // Handle different value types
        let valueString: string;
        if (typeof fieldValue === 'string') {
          // Properly escape quotes in strings
          const escapedValue = fieldValue.replace(/"/g, '\\"');
          valueString = `"${escapedValue}"`;
        } else if (typeof fieldValue === 'number') {
          valueString = fieldValue.toString();
        } else if (typeof fieldValue === 'boolean') {
          valueString = fieldValue.toString();
        } else if (fieldValue === null) {
          valueString = 'null';
        } else if (fieldValue === undefined) {
          valueString = 'undefined';
        } else {
          // Convert other types to string and escape quotes
          const escapedValue = String(fieldValue).replace(/"/g, '\\"');
          valueString = `"${escapedValue}"`;
        }
        
        // Replace the field name with its value using word boundaries
        const regex = new RegExp(`\\b${fieldName}\\b`, 'g');
        safeExpression = safeExpression.replace(regex, valueString);
      });
    }

    // Use Function constructor for safe evaluation (safer than eval)
    // eslint-disable-next-line no-new-func
    const func = new Function(`return ${safeExpression};`);
    const result = func();

    return Boolean(result);
  } catch (error) {
    console.warn('Error evaluating expression:', expression, error);
    return false;
  }
};